export const daysBetween = (from: Date, to: Date): number => {
  const numberOfDays = Math.round((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24));

  return numberOfDays || 0;
};
